import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  output,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Dialog } from 'primeng/dialog';
import { PrimengDialogDirective } from '@web/shared/ui';
import { NewsletterFormComponent } from '../newsletter-form/newsletter-form.component';
import { NewsletterFormData } from '../../models/newsletter-form-data';
import { NewsletterDataSourceService } from '../../services/newsletter-data-source.service';
import { UserInfoProviderService } from '../../providers/user-info-provider.service';
import { Observable, of, switchMap } from 'rxjs';
import { negate } from '@web/utils';

@Component({
  selector: 'app-newsletter-banner',
  imports: [
    CommonModule,
    Dialog,
    PrimengDialogDirective,
    NewsletterFormComponent,
  ],
  templateUrl: './newsletter-banner.component.html',
  styleUrl: './newsletter-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsletterBannerComponent {
  private readonly newsletterDataSource = inject(NewsletterDataSourceService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly userInfo = inject(UserInfoProviderService);

  public readonly submitSuccessEvent = output<void>();

  protected readonly shouldShowBanner$ = this.shouldShowBannerSource();

  protected showNewsletterDialog = false;

  protected handleClick(): void {
    this.showNewsletterDialog = true;
    this.changeDetectorRef.detectChanges();
  }

  protected handleSubmitClickEvent(data: NewsletterFormData): void {
    this.newsletterDataSource.subscribeByFormData(data).subscribe(() => {
      this.submitSuccessEvent.emit();
      this.showNewsletterDialog = false;
      this.changeDetectorRef.detectChanges();
    });
  }

  private shouldShowBannerSource(): Observable<boolean> {
    return this.userInfo.isLoggedIn().pipe(
      switchMap((isLoggedIn) => {
        if (isLoggedIn) {
          return this.userInfo.isSubscriber().pipe(negate());
        }

        return of(true);
      }),
    );
  }
}
